// export const publi_lmt_registration = [
export const non_public_lmt_registration = [
  {
    ip1: "कम्पनी रहने ठेगाना",
    type: "text",
    name: "company_address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "सम्बन्धित ब्यक्तीको नाम",
    type: "text",
    name: "contact_person",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  // {
  //   ip1: " कम्पनीको प्रकार",
  // },
  {
    ip1: "सम्बन्धित ब्यक्तीको सम्पर्क नं.",
    type: "number",
    name: "conatact_number",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  // confusion
  {
    ip1: "जम्मा सदस्य संख्या",
    type: "number",
    name: "total_share_holders",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  // confusion
  {
    ip1: " सदस्यहरुसंग कलेक्सन  गर्ने जम्मा रकम ",
    type: "number",
    name: "colletible_amount",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
];

export const non_profit_details_of_shareholder = [
  {
    ip1: "क्र. स.",
    name: "s.no",
  },
  {
    ip1: " सदस्यहरुको नाम",
    type: "text",
    name: "name",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "  हालको ठेगाना",
    type: "text",
    name: "address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  {
    ip1: "संकलन गरिएको रकम",
    type: "number",
    name: "share_amount",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "सदस्यको नागरिकता",
    type: "file",
    name: "citizenship",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: " साँक्षीको नाम",
    type: "text",
    name: "witness_name",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
  {
    ip1: "साँक्षीको ठेगाना",
    type: "text",
    name: "witness_address",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },

  {
    ip1: " साँक्षीको नागरिकता",
    type: "file",
    name: "witness_citizenship",
    validation: {
      required: {
        value: true,
        message: "this field is mandatory",
      },
    },
  },
];


export const non_profit_shareholder =  non_profit_details_of_shareholder.filter(item=> item.name !=="s.no").reduce((a,v)=>({...a, [v.name]:""}),{})


